module.exports = __webpack_public_path__ + "img/interactivevoiceresponse@small.e28bf8c6.jpg";